import './contact.css';
import React, {  useState } from 'react';
 
import { send } from 'emailjs-com';
 



const Contact = () => {

 const [sender_name, set_sender_name] = useState('');
 const [sender_email, set_sender_email] = useState('');
 const [message, set_message] = useState('');


 const handleName = (e) =>{
    set_sender_name(e.target.value)

 }
 const handleEmail =(e) =>{
    set_sender_email(e.target.value)

 }
 const handlemessage = (e) =>{
    set_message(e.target.value)

 }

 const sendMail = (e) => {
    e.preventDefault();
    send(
        'service_zss12is',
        'template_6jc034n',
        {sender_name, sender_email, message},
        'DOsTpdVluJoqGpVMa'
    )
    .then((response)=>{
        console.log('message sent successfully ',response.status, response.text)
    })
    .catch((err) =>{
        console.log('Failed', err)
    })
    set_sender_name('');
    set_sender_email('');
    set_message('');
 }

    return (
        <div name='contact' className="contact">
            <div className='row'>
                <div className="email-box reveal">
                    <img src="https://cdn.dribbble.com/users/722246/screenshots/4087457/media/de172b5a2287a8ca9900e716fd36d7c8.gif" border="0" alt="animated-email" />
                </div>
                <div className="contact-form">
                    <form onSubmit={sendMail}>

                        <h1>Get In Touch</h1>
                       
                        <div className="singleItem">

                            <input type='text'
                                className='name'
                                value={sender_name}
                                onChange={handleName}
                                name='sender_name'
                                placeholder='Name...'

                            />
                        </div>
                         
                        <div className="singleItem">

                            <input type='email'
                                name='sender_email'
                                value={sender_email}
                                onChange={handleEmail}
                                className='email'
                                placeholder='Email...'

                            />
                        </div>




                        <div className='textArea singleItem'>


                            <textarea
                                id=""
                                name='message'
                                value={message}
                                onChange={handlemessage}
                                cols='30' rows='3'
                                placeholder="Leave your Message..."

                            ></textarea>
                        </div>
                        <div className="msg" >
                            {send && "Message has been sent"}
                        </div>
                        <button type="submit" class="button-73"  >Submit</button>
                    </form>
                </div>
            </div>


            <div className='footer'>
                <div className='socialMedia'>
                    <ul className='sci'>
                        <li data-text='facebook' >
                            <a href='https://www.facebook.com/Ashishkarotiya7171' className='facebook'>
                                <i className="fa fa-facebook" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li data-text='linkedin'  >
                            <a href='https://www.linkedin.com/in/ashish-kumar-31624a214' className='linkedin'>
                                <i className="fa fa-linkedin" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li data-text='instagram' >
                            <a href='https://www.instagram.com/Ashishkarotiya7171' className='instagram'>
                                <i className="fa fa-instagram" aria-hidden="true"></i>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className='address'>
                    <p>Sarita Vihar, New Delhi - 110076</p>
                    <p>8851385257</p>
                </div>

            </div>

        </div>


    )

}
export default Contact